var _style, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconApi(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 600 600",
    style: {
      enableBackground: "new 0 0 600 600"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n\t.st1{fill:url(#SVGID_00000176005372323864828190000015187154180388455826_);}\n\t.st2{fill:url(#SVGID_00000129206022222848470620000009795331166116773544_);}\n\t.st3{fill:url(#SVGID_00000065757814204584932390000013099776256626529687_);}\n\t.st4{fill:url(#SVGID_00000136372411815824724330000014929978770274857358_);}\n\t.st5{fill:url(#SVGID_00000010292312827510905030000004635686542561608106_);}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: -16.3031,
    y1: 299.9693,
    x2: 577.6843,
    y2: 299.9693
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#092620"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1121,
    style: {
      stopColor: "#1D4D2F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2703,
    style: {
      stopColor: "#367D40"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4278,
    style: {
      stopColor: "#4BA64F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5815,
    style: {
      stopColor: "#5BC55A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7305,
    style: {
      stopColor: "#67DB62"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8724,
    style: {
      stopColor: "#6EE867"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#70ED69"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M300,232.1c-37.4,0-67.8,30.4-67.8,67.9c0,37.4,30.4,67.8,67.8,67.8s67.8-30.4,67.8-67.8 C367.8,262.6,337.4,232.1,300,232.1z M300,349.2c-27.1,0-49.2-22.1-49.2-49.2c0-27.1,22.1-49.2,49.2-49.2 c27.1,0,49.2,22.1,49.2,49.2C349.2,327.1,327.1,349.2,300,349.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000070086834315301591970000008890189996226325428_",
    gradientUnits: "userSpaceOnUse",
    x1: -16.3031,
    y1: 300.0004,
    x2: 577.6843,
    y2: 300.0004
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#092620"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1121,
    style: {
      stopColor: "#1D4D2F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2703,
    style: {
      stopColor: "#367D40"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4278,
    style: {
      stopColor: "#4BA64F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5815,
    style: {
      stopColor: "#5BC55A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7305,
    style: {
      stopColor: "#67DB62"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8724,
    style: {
      stopColor: "#6EE867"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#70ED69"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000070086834315301591970000008890189996226325428_)"
    },
    d: "M434.7,265l-37.3-5.3 c-3.5-8.6-8.3-16.4-13.8-23.8l14.1-35c1.3-3.2,0-6.9-3.1-8.6L346,164.1c-3.1-1.7-6.9-1-9,1.7l-23.2,29.7c-4.5-0.6-9-1-13.8-1 c-4.8,0-9.3,0.4-13.8,1L263,165.8c-2.1-2.7-5.9-3.4-9-1.7l-48.6,28.1c-3.1,1.7-4.2,5.5-3.1,8.6l14.1,35 c-5.6,7.3-10.3,15.2-13.8,23.8l-37.3,5.3c-3.4,0.4-5.9,3.4-5.9,6.9v56.2c0,3.5,2.5,6.5,5.9,6.9l37.3,5.3 c3.5,8.6,8.3,16.5,13.8,23.8l-14.1,35c-1.3,3.2,0,6.9,3.1,8.6l48.6,28.1c3.1,1.8,6.9,1,9-1.7l23.2-29.7c4.5,0.6,9.1,1,13.8,1 c4.6,0,9.3-0.4,13.8-1l23.2,29.7c2.1,2.7,5.9,3.4,9,1.7l48.6-28.1c3.1-1.7,4.2-5.5,3.1-8.6l-14.1-35c5.6-7.3,10.3-15.2,13.8-23.8 l37.3-5.3c3.4-0.4,5.9-3.4,5.9-6.9v-56.2C440.6,268.3,438.1,265.4,434.7,265z M422,318l-37.7,5.4l-4,9.8 c-2.8,6.9-6.5,13.2-11.3,19.5l-6.5,8.4l14.2,35.4l-31.2,18.1l-23.5-30l-10.5,1.3c-3.7,0.5-7.6,0.8-11.5,0.8 c-3.9,0-7.7-0.4-11.5-0.8l-10.5-1.3l-23.5,30l-31.2-18.1l14.2-35.3l-6.3-8.4c-5-6.7-8.8-13.1-11.4-19.7l-4-9.9L178,318v-36 l37.7-5.4l4-9.9c2.8-6.9,6.5-13.2,11.3-19.5l6.5-8.4l-14.2-35.4l31.2-18.1l23.5,30l10.5-1.3c3.7-0.5,7.5-0.8,11.5-0.8 c4,0,7.7,0.4,11.5,0.8l10.5,1.3l23.5-30l31.2,18.1l-14.2,35.3l6.3,8.4c5,6.7,8.8,13.1,11.5,19.7l4,9.8L422,282V318z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000066512510611316610920000013810597603779193008_",
    gradientUnits: "userSpaceOnUse",
    x1: -16.3031,
    y1: 300.0006,
    x2: 577.6843,
    y2: 300.0006
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#092620"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1121,
    style: {
      stopColor: "#1D4D2F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2703,
    style: {
      stopColor: "#367D40"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4278,
    style: {
      stopColor: "#4BA64F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5815,
    style: {
      stopColor: "#5BC55A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7305,
    style: {
      stopColor: "#67DB62"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8724,
    style: {
      stopColor: "#6EE867"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#70ED69"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000066512510611316610920000013810597603779193008_)"
    },
    d: "M134.5,288.7H73 c-4.6-12.7-16.7-21.8-30.9-21.8C23.8,266.9,9,281.7,9,300c0,18.3,14.8,33.1,33.1,33.1c14.3,0,26.3-9.1,30.9-21.8h61.5 c6.2,0,11.3-5.1,11.3-11.3C145.8,293.8,140.7,288.7,134.5,288.7z M42.1,313.7c-7.6,0-13.7-6.1-13.7-13.7c0-7.6,6.1-13.7,13.7-13.7 s13.7,6.1,13.7,13.7C55.7,307.5,49.6,313.7,42.1,313.7z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000132770954965898909670000000788034904065526694_",
    gradientUnits: "userSpaceOnUse",
    x1: -16.3031,
    y1: 300.0006,
    x2: 577.6843,
    y2: 300.0006
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#092620"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1121,
    style: {
      stopColor: "#1D4D2F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2703,
    style: {
      stopColor: "#367D40"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4278,
    style: {
      stopColor: "#4BA64F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5815,
    style: {
      stopColor: "#5BC55A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7305,
    style: {
      stopColor: "#67DB62"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8724,
    style: {
      stopColor: "#6EE867"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#70ED69"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000132770954965898909670000000788034904065526694_)"
    },
    d: "M557.9,266.9c-14.3,0-26.3,9.1-30.9,21.8 h-61.5c-6.2,0-11.3,5.1-11.3,11.3c0,6.2,5.1,11.3,11.3,11.3H527c4.6,12.7,16.7,21.8,30.9,21.8c18.3,0,33.1-14.8,33.1-33.1 C591,281.7,576.2,266.9,557.9,266.9z M557.9,313.7c-7.6,0-13.7-6.1-13.7-13.7c0-7.5,6.1-13.7,13.7-13.7c7.6,0,13.7,6.1,13.7,13.7 C571.6,307.6,565.5,313.7,557.9,313.7z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000121992817776964007070000011496080011190174595_",
    gradientUnits: "userSpaceOnUse",
    x1: -16.3031,
    y1: 77.4064,
    x2: 577.6843,
    y2: 77.4064
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#092620"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1121,
    style: {
      stopColor: "#1D4D2F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2703,
    style: {
      stopColor: "#367D40"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4278,
    style: {
      stopColor: "#4BA64F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5815,
    style: {
      stopColor: "#5BC55A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7305,
    style: {
      stopColor: "#67DB62"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8724,
    style: {
      stopColor: "#6EE867"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#70ED69"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000121992817776964007070000011496080011190174595_)"
    },
    d: "M288.7,73v61.5c0,6.2,5.1,11.3,11.3,11.3 c6.2,0,11.3-5.1,11.3-11.3V73c12.7-4.6,21.8-16.7,21.8-30.9C333.1,23.8,318.3,9,300,9c-18.3,0-33.1,14.8-33.1,33.1 C266.9,56.3,276,68.4,288.7,73z M300,28.4c7.6,0,13.7,6.1,13.7,13.7s-6.1,13.7-13.7,13.7c-7.5,0-13.7-6.1-13.7-13.7 S292.5,28.4,300,28.4z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000060019297433358907070000015294599108643136905_",
    gradientUnits: "userSpaceOnUse",
    x1: -16.3031,
    y1: 522.5947,
    x2: 577.6843,
    y2: 522.5947
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#092620"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1121,
    style: {
      stopColor: "#1D4D2F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2703,
    style: {
      stopColor: "#367D40"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4278,
    style: {
      stopColor: "#4BA64F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5815,
    style: {
      stopColor: "#5BC55A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7305,
    style: {
      stopColor: "#67DB62"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8724,
    style: {
      stopColor: "#6EE867"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#70ED69"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000060019297433358907070000015294599108643136905_)"
    },
    d: "M311.3,527v-61.5 c0-6.2-5.1-11.3-11.3-11.3c-6.2,0-11.3,5.1-11.3,11.3V527c-12.7,4.6-21.8,16.7-21.8,30.9c0,18.3,14.8,33.1,33.1,33.1 c18.3,0,33.1-14.8,33.1-33.1C333.1,543.7,324,531.6,311.3,527z M300,571.6c-7.6,0-13.7-6.1-13.7-13.7c0-7.6,6.1-13.7,13.7-13.7 c7.5,0,13.7,6.1,13.7,13.7C313.7,565.5,307.5,571.6,300,571.6z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconApi);
export default __webpack_public_path__ + "static/media/icon-api.be98849da7ee37f7164d4945a336692d.svg";
export { ForwardRef as ReactComponent };